import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_array from "@swc/helpers/src/_to_array.mjs";
import { darken, lighten } from "@mui/system/colorManipulator";
import componentOverrides from "../component-overrides";
var tonalOffset = 0.5;
function addLightAndDark(main) {
    return {
        main: main,
        light: lighten(main, tonalOffset),
        dark: darken(main, tonalOffset * 1.5)
    };
}
var gradientStart = new Date("2023-08-23T17:13:07.126Z").getTime();
var gradientEnd = new Date("2023-12-30T00:00:00.000Z").getTime();
var time = new Date().getTime();
// For testing colors in advance - gives Shu-Yi a few months to settle on the ones we have now.
var forcedPercentage = typeof document !== "undefined" && document.location.search.includes("fullThemeColors") ? 1 : 0;
var transitionPercentage = forcedPercentage || Math.min(Math.max(0, (time - gradientStart) / (gradientEnd - gradientStart)), 1);
var padHex = function(hex, len) {
    return "".concat("0".repeat(Math.max(0, len - hex.length))).concat(hex);
};
var identityTransition = function(from, to) {
    var _from = _to_array(from), fromColors = _from.slice(1);
    var _to = _to_array(to), toColors = _to.slice(1);
    var ref = _sliced_to_array(fromColors.join("").match(/.{1,2}/g), 3), fromR = ref[0], fromG = ref[1], fromB = ref[2];
    var ref1 = _sliced_to_array(toColors.join("").match(/.{1,2}/g), 3), toR = ref1[0], toG = ref1[1], toB = ref1[2];
    var result = [
        [
            fromR,
            toR
        ],
        [
            fromG,
            toG
        ],
        [
            fromB,
            toB
        ], 
    ].map(function(param) {
        var _param = _sliced_to_array(param, 2), _$from = _param[0], _$to = _param[1];
        var startColor = parseInt(_$from, 16);
        return padHex(Math.min(255, Math.floor(startColor + transitionPercentage * (parseInt(_$to, 16) - startColor))).toString(16), 2).toUpperCase();
    }).join("");
    return "#".concat(result);
};
var theme = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 1650
        }
    },
    components: componentOverrides,
    typography: {
        fontSize: 13,
        fontFamily: [
            "Inter",
            "Roboto",
            "Helvetica",
            "Arial"
        ].join(",")
    },
    palette: {
        tonalOffset: tonalOffset,
        contrastThreshold: 3,
        common: {
            black: "#000000",
            white: "#FFFFFF"
        },
        primary: {
            main: "#6C45EE"
        },
        secondary: {
            main: "#FF00CC"
        },
        // NOTE: The following are used for status boxes, andon buttons etc.
        error: {
            main: identityTransition("#D0021B", "#FF5757")
        },
        warning: {
            main: identityTransition("#F5A623", "#FFD15B")
        },
        info: {
            main: identityTransition("#ADDFEF", "#6DD1F1")
        },
        success: {
            main: identityTransition("#59B78C", "#8DC68F")
        }
    },
    blackbird: {
        alarms: {
            type: {
                AboveX: {
                    color: "#D9534F"
                },
                BelowX: {
                    color: "#D9534F"
                },
                AboveXForTSeconds: {
                    color: "#5BC0DE"
                },
                BelowXForTSeconds: {
                    color: "#5BC0DE"
                },
                AboveXForTSecondsWithinYTimeNTimes: {
                    color: "#F0AD4E"
                },
                BelowXForTSecondsWithinYTimeNTimes: {
                    color: "#F0AD4E"
                },
                SumOfTAboveXWithinYTime: {
                    color: "purple"
                },
                SumOfTBelowXWithinYTime: {
                    color: "purple"
                }
            }
        },
        stops: {
            NO_ACT: {
                color: addLightAndDark(identityTransition("#ADDFEF", "#DFF4FD"))
            },
            NON_PROD: {
                color: addLightAndDark("#E0E0E0")
            },
            BATCH_NON_PROD: {
                color: addLightAndDark(identityTransition("#F8D6A7", "#FAECC4"))
            },
            DOWNTIME: {
                color: addLightAndDark(identityTransition("#D99896", "#EEC7C6"))
            },
            UNREGISTERED: {
                color: addLightAndDark(identityTransition("#BDBDBD", "#858585"))
            },
            MICRO_STOP: {
                color: addLightAndDark("#E0E0E0")
            },
            UNREGISTERED_PLOT_BAND: {
                color: addLightAndDark(identityTransition("#D99896", "#EEC7C6"))
            }
        },
        tableRows: {
            color: {
                hovered: "lightgray"
            }
        }
    }
};
export var base = theme;
